import { Component, OnInit } from '@angular/core';
import {SttTableComponent} from '../../../../shared/components/stt-table/stt-table.component';
import {DialogService, DynamicDialogRef} from 'primeng/dynamicdialog';
import { RecipeModel } from 'src/app/shared/entities/recipe.model';
import { RecipeAddEditComponent } from '../recipe-add-edit/recipe-add-edit.component';
import { ConfirmationService, MessageService, PrimeNGConfig } from 'primeng/api';
import { ValidationMessageService } from '../../../../shared/services/base/validation-message-handle';
import { RecipeService } from '../../../../shared/services/app/recipe.service';
import { finalize } from "rxjs/operators";

@Component({
  selector: 'app-recipe-action-table',
  templateUrl: './recipe-action-table.component.html',
  styleUrls: ['./recipe-action-table.component.scss']
})
export class RecipeActionTableComponent implements OnInit {

  public data: RecipeModel;
  public table: SttTableComponent;
  public ref: DynamicDialogRef;
  public loading = true;

  constructor(
      public dialogService: DialogService,
      public confirmationService: ConfirmationService,
      public primengConfig: PrimeNGConfig,
      public itemService: RecipeService,
      public messageService: MessageService,
      private validationMessageService: ValidationMessageService,
  ) {

  }

  ngOnInit(): void {
  }

  setParams(entity: RecipeModel): void {
      this.data = entity;
  }

  setTableReference(table: SttTableComponent): void
  {
      this.table = table;
  }


  showDialog() {
      this.ref = this.dialogService.open(RecipeAddEditComponent, {
          header: 'Modificare reteta',
          width: '70%',
          contentStyle: {'max-height': '70vh'},
          baseZIndex: 10000,
          closeOnEscape: false,
          data: this.data,
      });

      this.ref.onClose.subscribe((item: RecipeModel) => {
          if (item) {
              this.table.refresh();
          }
      });
  }

    confirm() {
        this.confirmationService.confirm({
            header: 'Confirmare stergere Reteta',
            message: 'Sunteti sigur ca doriti sa stergeti aceasta Reteta?',
            key: 'deleteRecipe',
            icon: 'pi pi-exclamation-triangle',
            acceptLabel: 'Da',
            rejectLabel: 'Nu',
            acceptButtonStyleClass: 'p-button-md p-button-success',
            rejectButtonStyleClass: 'p-button-md p-button-danger',
            accept: () => {
                this.deleteItem(this.data.uid);
            },
            reject: () => {
                this.confirmationService.close();
                this.table.refresh();
            }
        });
    }

    deleteItem(uid: string){
        this.itemService.delete(uid)
            .pipe(finalize(() => {this.loading = false;this.table.refresh();}))
            .subscribe((response: any) => {
                this.messageService.add({
                    severity: 'success',
                    summary: 'Reteta a fost stearsa cu success!'
                });
            });
    }
}
